import React, { useState } from 'react'
import Geocode from 'react-geocode'
import { getLocalstoreData, getSessionstoreData } from '../Store/GetData'
import { Link as GatsbyLink } from 'gatsby'
import { toast } from 'react-toastify'
import isObject from 'lodash/isObject'
import { DeleteSessionstore } from '../Store/DeleteData'
import { components } from 'react-select'
import { verifyReferal } from './services'
import { Sessionstore } from '../Store/StoreData'

export const getBase64 = file => {
  return new Promise(resolve => {
    let baseURL = ''
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      baseURL = reader.result
      file['base64'] = baseURL
      var Base64 = file.base64.replace('data:image/png;base64,', '')
      resolve(Base64)
    }
  })
}

export const AddressToLatLng = Address => {
  return new Promise((resolve, reject) => {
    Geocode.fromAddress(Address, process.env.GOOGLE_API_KEY)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const toInputUppercase = e => {
  e.target.value = ('' + e.target.value).toUpperCase()
}

export const LatLngToAddress = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(function (position) {
      Geocode.fromLatLng(
        position.coords.latitude,
        position.coords.longitude,
        process.env.GOOGLE_API_KEY
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  })
}

export const ZohoSalesIQ = () => {
  if (typeof window !== 'undefined') {
    window.$zoho = window.$zoho || {}
    window.$zoho.salesiq = window.$zoho.salesiq || {
      mode: 'async',
      // widgetcode:
      //   '547132576f756f1db79fb47571364ec7a6aa969c2feaca4c13870a5b7b32eadc',
      widgetcode:'e00678aa2e8828d63c42e6c442df0d4b9c0641b383cca1a06ea0acd32d867c32e55f8ec58dcde8c764e48304f8376cc7',
      values: {},
      ready: function () {},
    }
    const d = document
    let s
    s = d.createElement('script')
    s.type = 'text/javascript'
    s.id = 'zsiqscript'
    s.defer = true
    s.src = 'https://salesiq.zoho.in/widget'
    let t
    t = d.getElementsByTagName('script')[0]
    t.parentNode.insertBefore(s, t)

    return (
      <React.Fragment>
        <div id="zsiqwidget"></div>
      </React.Fragment>
    )
  } else {
    return <div></div>
  }
}

export const Paymenthandle = (amountValue, orderid) => {
  return new Promise((resolve, reject) => {
    const user = getLocalstoreData('userdata')
    var amount = amountValue * 100
    const options = {
      key: process.env.RAZORPAY_KEY,
      amount: amount,
      currency: 'INR',
      name: 'AbleAura',
      description: `Add Money To Wallet`,
      image:
        'https://png.pngtree.com/element_our/png_detail/20181114/transaction-icon-png_239785.jpg',
      order_id: orderid,
      handler: function (data) {
        let finaldata = {
          ...data,
          amount: amount,
        }
        resolve(finaldata)
      },
      prefill: {
        name: user?.first_name || '',
        email: user?.email || '',
        contact: user?.phone || '',
      },
      theme: {
        color: '#000000',
      },
    }
    if (typeof window !== 'undefined') {
      const rzp1 = new window.Razorpay(options)
      rzp1.open()
      rzp1.on('payment.failed', function (response) {})
    }
  })
}

export const errortoast = message => {
  toast(message, {
    autoClose: true,
    containerId: 'errorToast',
    icon: ({ theme, type }) => (
      <span className="fa-solid fa-fire-flame-curved"></span>
    ),
  })
}

export const getFirstErrorKey = (object, keys = []) => {
  const firstErrorKey = Object.keys(object)[0]
  if (isObject(object[firstErrorKey])) {
    return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey])
  }
  return [...keys, firstErrorKey].join('.')
}

export const successtoast = message => {
  toast(message, {
    autoClose: true,
    containerId: 'successToast',
    icon: ({ theme, type }) => <i className="fa-solid fa-thumbs-up"></i>,
  })
}

const subscription_id = getLocalstoreData('subsid')

export const subscriptionHandle = (subscriptionid) => {
  return new Promise((resolve, reject) => {
    const loadRazorpay = async () => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      document.body.appendChild(script);

      await new Promise(resolve => {
        script.onload = resolve;
      });

      const user = getLocalstoreData('userdata');

      const rzp = new window.Razorpay({
        key: process.env.RAZORPAY_KEY,
        subscription_id: subscriptionid,
        currency: 'INR',
        name: 'Able Aura',
        description: 'Subscription Payment',
        image: 'https://able-email-media.s3.amazonaws.com/logo/logo_black.png',
        handler: function (data) {
          console.log("razorpay", data);
          resolve(data);
        },

        prefill: {
          name: user?.first_name || '',
          email: user?.email || '',
          contact: user?.phone || '',
        }
      });

      rzp.open();
    };

    loadRazorpay();
  });
};



























export const bytesToSize = bytes => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
}

export const ReadMore = ({ children }) => {
  const text = children
  const [isReadMore, setIsReadMore] = useState(true)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  return (
    <p className="text">
      {text ? (
        <>
          {isReadMore ? text.slice(0, 150) : text}
          {text.length >= 150 && (
            <span role='button' onClick={toggleReadMore} className="read-or-hide">
              {isReadMore ? 'See More' : ' Show Less'}
            </span>
          )}
        </>
      ) : (
        <>{children}</>
      )}
    </p>
  )
}

export function start_and_end(str) {
  if (str.length > 20) {
    return str.substr(0, 10) + '...' + str.substr(str.length - 10, str.length)
  }
  return str
}

export const Link = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  ...other
}) => {
  const internal = /^\/(?!\/)/.test(to)
  if (internal) {
    return (
      <GatsbyLink
        to={to}
        role={other.role ? other.role : 'link'}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    )
  } else if (to !== undefined) {
    return (
      <a role="link" href={to} {...other}>
        {children}
      </a>
    )
  } else {
    return <div {...other}>{children}</div>
  }
}
export default Link

export const UserAccessabilityWidget = () => {
  if (typeof window !== 'undefined') {
    var s = document.createElement('uawidget')
    var h = document.querySelector('head') || document.body
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'
    s.async = true
    s.onload = function () {
      document.acsbJS.init({
        statementLink: '',
        footerHtml: '',
        hideMobile: false,
        hideTrigger: false,
        disableBgProcess: false,
        language: 'en',
        position: 'left',
        leadColor: '#646c78',
        triggerColor: '#72777e',
        triggerRadius: '50%',
        triggerPositionX: 'right',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'medium',
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: 'small',
          triggerPositionX: 'right',
          triggerPositionY: 'center',
          triggerOffsetX: 10,
          triggerOffsetY: 0,
          triggerRadius: '50%',
        },
      })
    }
    h.appendChild(s)
    return (
      <React.Fragment>
        <div id="uawidget"></div>
      </React.Fragment>
    )
  } else {
    return <div style={{ background: 'red' }}></div>
  }
}






export const authNavigate = () => {
  const currentPath = getSessionstoreData('currentpath')
  console.log(currentPath, "currentpathss")
  if (getSessionstoreData('referalCode') !== null) {
    var referalCode = {
      referal_code: getSessionstoreData('referalCode'),
    }
    verifyReferal(referalCode)
      .then(response => {
        if (response.data.success) {
          DeleteSessionstore('referalCode')
        } else {
          DeleteSessionstore('referalCode')
        }
      })
      .catch(error => {
        DeleteSessionstore('referalCode')
        console.log(error.message)
      })
    return '/'
  } else if (getSessionstoreData('isFrom') === 'Cart') {
    DeleteSessionstore('isFrom')
    return '/cart'
  } else if (getSessionstoreData('isFrom') === 'servicelist'){
    DeleteSessionstore('isFrom')
    //Sessionstore("isFromservice", true)
    Sessionstore("currentpath", true,);
    return '/AccountConfigure/profile'
   
  }
  
  
  else {
    if (getSessionstoreData('benefitary') !== null) {
      let data = getSessionstoreData('benefitary')
      if (data === 1) {
        sessionStorage.removeItem('benefitary')
        return '/benefitary/upload'
      } else if (data === 2) {
        sessionStorage.removeItem('benefitary')
        return '/endoser/upload'
      }  else if (data === 3) {
        sessionStorage.removeItem('benefitary')
        return '/academy' 
      }
      else {
        return '/'
      }
    } else {
      return '/'
    }
  }
}

export const getAmountFromStringtoNumber = amountText => {
  return parseFloat(
    parseFloat(amountText)
      .toFixed(2)
      .replace(/(\d)(?=(\d{20})+(?!\d))/g, '$1,')
  )
}

export const InputSelect = props => (
  <components.Input {...props} maxLength={25} />
)

export const isValidFileUploaded = (file, extevalidExtensionsn) => {
  return extevalidExtensionsn.some(format =>
    file.name.toLowerCase().endsWith(format.toLowerCase())
  )
}

// export var HeadComponents = [
//   <meta charSet="utf-8" />,
//   <meta
//     name="viewport"
//     content="width=device-width, initial-scale=1, maximum-scale=3, user-scalable=yes"
//   />,
//   <title>ableaura</title>,
// ]

// export const HeadComponents = [
//   <meta charSet="utf-8" />,
//   <meta
//     name="viewport"
//     content="width=device-width, initial-scale=1, maximum-scale=3, user-scalable=yes"
//   />,
//   <title>ableaura</title>,
//   <meta
//     name="description"
//     content="India's first PWD Ecosystem Ableaura"
//     data-react-helmet="true"
//   />,
//   <meta itemprop="name" content="ableaura" data-react-helmet="true" />,
//   <meta
//     itemprop="description"
//     content="super senior soundar"
//     data-react-helmet="true"
//   />,
//   <meta
//     itemprop="image"
//     content="http://developer.android.com/images/social/android-developers.png"
//     data-react-helmet="true"
//   />,
//   <meta property="og:type" content="website" data-react-helmet="true" />,
//   <meta property="og:title" content="ableaura" data-react-helmet="true" />,
//   <meta
//     property="og:description"
//     content="super senior soundar"
//     data-react-helmet="true"
//   />,
//   <meta
//     property="og:image"
//     content="http://developer.android.com/images/social/android-developers.png"
//     data-react-helmet="true"
//   />,
//   <meta
//     name="twitter:card"
//     content="summary_large_image"
//     data-react-helmet="true"
//   />,
//   <meta name="twitter:title" content="ableaura" data-react-helmet="true" />,
//   <meta
//     name="twitter:description"
//     content="super senior soundar"
//     data-react-helmet="true"
//   />,
//   <meta
//     name="twitter:image"
//     content="http://developer.android.com/images/social/android-developers.png"
//     data-react-helmet="true"
//   />,
// ]
